import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateTaxRate($companyId: ID!, $attributes: TaxRateAttributes!) {
    createTaxRate(companyId: $companyId, attributes: $attributes) {
       taxRate {
        id
        ...CreatedTaxRate
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedTaxRate on TaxRate {
    id
    name
    rate
  }
`
